import template from './menu-items.html';

import { toggleSubmenu, closeAllSideMenuItems } from 'auth/actions/session.actions';

const mapStateToThis = ({ session, documents }) => {
  const { sidemenu, locale } = session;
  const { newLabel } = documents;

  return {
    menuItems: sidemenu,
    newLabel,
    locale,
  };
};

const mapDispatchToThis = {
  toggleSubmenu,
  closeAllSideMenuItems,
};

@Inject('$ngRedux', 'Responsive', '$document', '$window')
class SideMenuItemsController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.$window.addEventListener('resize', this.closeAllSideMenuItems);
  }

  $onDestroy() {
    this.$window.removeEventListener('resize', this.closeAllSideMenuItems);
    this.unsubscribe();
  }

  handleItemClick(item) {
    const element = this.$document[0].querySelector('body');
    const hasMiniBar = angular.element(element).hasClass('mini-navbar');

    if (this.Responsive.isPhone || this.Responsive.isTablet) {
      if (!hasMiniBar) angular.element(element).addClass('mini-navbar');
    }

    if (hasMiniBar) this.toggleSubmenu(item);
  }
}

class SideMenuItemsComponent {
  constructor() {
    this.controller = SideMenuItemsController;
    this.template = template;
    return this;
  }
}

export default SideMenuItemsComponent;



// WEBPACK FOOTER //
// ./src/modules/app/components/side-menu/components/menu-items/menu-items.js